import axios from "axios";

const axiosCoralie = axios.create()

axiosCoralie.interceptors.request.use(
    config => {
        const token = localStorage.getItem('accessToken')

        // TODO remplace l'auth MO
        config.headers['Authorization'] = 'Bearer ' + token ?? ''
        return config
    },
    error => {
        return new Promise((resolve, reject) => {
            reject(error)
        })
    }
)

axiosCoralie.interceptors.response.use((response) => {

    return new Promise((resolve, reject) => {
        resolve(response)
    })
    // return response
}, error => {
    // TODO passe pas dans le catch, pète juste une err dans le JS mais on récup pas le body pour le traiter
    // Promise.reject(error)
    // TODO tombe dans le then, pas dans le catch
    // return error
    return new Promise((resolve, reject) => {
        reject(error)
    })
})

export default axiosCoralie